
<script>
import http from '@/service/http'
import { mapState } from 'vuex'
export default {
  name: 'Form',
  data () {
    return {
      fornecedor: {
        id: '',
        fornecedor: '',
        tipo: 1,
        responsavel: '',
        cnpj: '',
        razao_social: '',
        cpf: '',
        rg: '',
        email: '',
        telefone: '',
        telefone2: '',
        telefone3: '',
        cep: '',
        logradouro: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: '',
        obs: '',
        ativo: true
      }
    }
  },
  mounted () {
    this.fecth()
  },
  watch: {
    '$route' () {
      if (this.$route.params.id != null) {
        this.fecth()
      }
    },
    hasAll () {
      if (this.hasAll) {
        this.all = true
      } else {
        this.all = false
      }
    }
  },
  methods: {
    setEndereco () {
      window.$.getJSON(`https://viacep.com.br/ws/${this.fornecedor.cep}/json/`)
      .then(response => {
        if (!response.erro) {
          this.fornecedor.logradouro = response.logradouro
          this.fornecedor.bairro = response.bairro
          this.fornecedor.cidade = response.localidade
          this.fornecedor.estado = response.uf
          $('#numero').focus()
        } else {
          this.fornecedor.logradouro = ''
          this.fornecedor.numero = ''
          this.fornecedor.complemento = ''
          this.fornecedor.bairro = ''
          this.fornecedor.cidade = ''
          this.fornecedor.estado = ''
        }
        setTimeout(function () {
          window.Materialize.updateTextFields()
        }, 0)
      })
    },
    validate () {
      this.$validator.validateAll().then(success => {
        if (!success) {
          this.$swal({
            title: 'Ops, encontramos um erro!',
            html: 'Um ou mais campos estão com seu preenchimento incorreto',
            type: 'error',
            cancelButtonText: 'Ok'
          })
          return false
        } else {
          this.submit()
        }
      })
    },
    async submit () {
      const verb = this.isNew ? 'post' : 'put'
      const url = this.isNew ? '/fornecedores' : `/fornecedores/${this.fornecedor.id}`
      const { data } = await http[verb](url, this.fornecedor)
      if (data != null) {
        this.$emit('update-fornecedores-list', { fornecedor: data.fornecedor })
        this.$router.push({ name: 'fornecedores.index' })
      }
    },
    async fecth () {
      this.clear()
      const { id } = this.$route.params
      if (id !== undefined) {
        const { data } = await http.get(`/fornecedores/${id}/edit`)
        this.fornecedor = data.fornecedor
        setTimeout(function () {
          window.Materialize.updateTextFields()
        }, 0)
      }
      $('.collapsible').collapsible()
      $('.collapsible').collapsible('close', 0)
      $('.collapsible').collapsible('close', 1)
      $('.collapsible').collapsible('close', 2)
      $('.collapsible').collapsible('open', 0)
    },
    clear () {
      this.fornecedor = {
        id: '',
        fornecedor: '',
        tipo: 1,
        responsavel: '',
        cnpj: '',
        razao_social: '',
        cpf: '',
        rg: '',
        email: '',
        telefone: '',
        telefone2: '',
        telefone3: '',
        cep: '',
        logradouro: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: '',
        obs: '',
        ativo: true
      }
    }
  },
  computed: {
    ...mapState(['loading']),
    isNew () {
      return this.fornecedor.id === ''
    }
  }
}
</script>

<template>
  <div>

    <form @submit.prevent="validate">

      <div class="row">

        <div class="col s12 m10 offset-m1">

          <ul class="collapsible popout" data-collapsible="accordion">

            <li>
              <div class="collapsible-header"><i class="material-icons">person</i>Fornecedor</div>
              <div class="collapsible-body">

                <div class="row">
                  <div class="input-field col s12 m7">
                    <input name="fornecedor" id="fornecedor" type="text" v-validate data-vv-rules="required" :class="{invalid: errors.has('fornecedor')}" v-model="fornecedor.fornecedor">
                    <label for="fornecedor">*Fornecedor</label>
                    <small class="red-text">{{ errors.first('fornecedor') }}</small>
                  </div>
                  <div class="col s12 m3">
                    <label for="tipo">*Tipo</label>
                    <select name="tipo" id="tipo" v-validate data-vv-rules="required" :class="{invalid: errors.has('tipo')}" v-model.number="fornecedor.tipo">
                      <option value="1">Pessoa Jurídica</option>
                      <option value="2">Pessoa Física</option>
                    </select>
                    <small class="red-text">{{ errors.first('tipo') }}</small>
                  </div>
                  <div class="input-field col s12 m2">
                    <input name="ativo" id="ativo" type="checkbox" v-model="fornecedor.ativo">
                    <label for="ativo">Ativo</label>
                  </div>
                </div>

                <div class="row">
                  <div class="input-field col s12 m4" v-show="fornecedor.tipo === 1">
                    <input name="responsavel" id="responsavel" type="text" v-validate data-vv-rules="required" :class="{invalid: errors.has('responsavel')}" v-model="fornecedor.responsavel">
                    <label for="responsavel">*Responsável</label>
                    <small class="red-text">{{ errors.first('responsavel') }}</small>
                  </div>
                  <div class="input-field col s12 m4" v-show="fornecedor.tipo === 1">
                    <input name="razao_social" id="razao_social" type="text" v-model="fornecedor.razao_social">
                    <label for="razao_social">Razão Social</label>
                    <small class="red-text">{{ errors.first('razao_social') }}</small>
                  </div>
                  <div class="input-field col s12 m4" v-show="fornecedor.tipo === 1">
                    <input name="cnpj" id="cnpj" type="text" v-mask="'99.999.999/9999-99'" v-validate data-vv-rules="min:18" :class="{invalid: errors.has('cnpj')}" v-model="fornecedor.cnpj">
                    <label for="cnpj">CNPJ</label>
                    <small class="red-text">{{ errors.first('cnpj') }}</small>
                  </div>
                  <div class="input-field col s12 m4" v-show="fornecedor.tipo === 2">
                    <input name="rg" id="rg" type="text" v-model="fornecedor.rg">
                    <label for="rg">RG</label>
                    <small class="red-text">{{ errors.first('rg') }}</small>
                  </div>
                  <div class="input-field col s12 m4" v-show="fornecedor.tipo === 2">
                    <input name="cpf" id="cpf" type="text" v-mask="'999.999.999-99'" v-validate data-vv-rules="min:14" :class="{invalid: errors.has('cpf')}" v-model="fornecedor.cpf">
                    <label for="cpf">CPF</label>
                    <small class="red-text">{{ errors.first('cpf') }}</small>
                  </div>
                </div>

                <div class="row">
                  <div class="input-field col s12 m3">
                    <input name="telefone" id="telefone" type="text" v-mask="'(99) 99999999[9]'" v-validate data-vv-rules="min:13" :class="{invalid: errors.has('telefone')}" v-model="fornecedor.telefone">
                    <label for="telefone">Telefone</label>
                    <small class="red-text">{{ errors.first('telefone') }}</small>
                  </div>
                  <div class="input-field col s12 m3">
                    <input name="telefone2" id="telefone2" type="text" v-mask="'(99) 99999999[9]'" v-validate data-vv-rules="min:13" :class="{invalid: errors.has('telefone2')}" v-model="fornecedor.telefone2">
                    <label for="telefone2">Telefone</label>
                    <small class="red-text">{{ errors.first('telefone2') }}</small>
                  </div>
                  <div class="input-field col s12 m3">
                    <input name="telefone3" id="telefone3" type="text" v-mask="'(99) 99999999[9]'" v-validate data-vv-rules="min:13" :class="{invalid: errors.has('telefone3')}" v-model="fornecedor.telefone3">
                    <label for="telefone3">Telefone</label>
                    <small class="red-text">{{ errors.first('telefone3') }}</small>
                  </div>
                  <div class="input-field col s12 m3">
                    <input name="email" id="email" type="text" v-validate data-vv-rules="required|email" :class="{invalid: errors.has('responsavel')}" v-model="fornecedor.email">
                    <label for="email">E-mail</label>
                    <small class="red-text">{{ errors.first('email') }}</small>
                  </div>
                </div>

              </div>

            </li>

            <li>
              <div class="collapsible-header"><i class="material-icons">place</i> Endereço</div>
              <div class="collapsible-body">

                <div class="row">
                  <div class="input-field col s12 m3">
                    <input name="cep" id="cep" type="text" v-mask="'99999-999'" v-validate data-vv-rules="min:9" :class="{invalid: errors.has('cep')}" @blur="setEndereco" v-model="fornecedor.cep">
                    <label for="cep">CEP</label>
                    <small class="red-text">{{ errors.first('cep') }}</small>
                  </div>
                  <div class="input-field col s12 m5">
                    <input name="logradouro" id="logradouro" type="text" v-model="fornecedor.logradouro">
                    <label for="logradouro">Logradouro</label>
                    <small class="red-text">{{ errors.first('logradouro') }}</small>
                  </div>
                  <div class="input-field col s12 m2">
                    <input name="numero" id="numero" type="text" v-model="fornecedor.numero">
                    <label for="numero">Nº</label>
                    <small class="red-text">{{ errors.first('numero') }}</small>
                  </div>
                  <div class="input-field col s12 m2">
                    <input name="complemento" id="complemento" type="text" v-model="fornecedor.complemento">
                    <label for="complemento">Compl.</label>
                    <small class="red-text">{{ errors.first('complemento') }}</small>
                  </div>
                </div>

                <div class="row">
                  <div class="input-field col s12 m5">
                    <input name="bairro" id="bairro" type="text" v-model="fornecedor.bairro">
                    <label for="bairro">Bairro</label>
                    <small class="red-text">{{ errors.first('bairro') }}</small>
                  </div>
                  <div class="input-field col s12 m5">
                    <input name="cidade" id="cidade" type="text" v-model="fornecedor.cidade">
                    <label for="cidade">Cidade</label>
                    <small class="red-text">{{ errors.first('cidade') }}</small>
                  </div>
                  <div class="input-field col s12 m2">
                    <input name="estado" id="estado" type="text" v-model="fornecedor.estado">
                    <label for="estado">Estado</label>
                    <small class="red-text">{{ errors.first('estado') }}</small>
                  </div>
                </div>

              </div>
            </li>

            <li>
              <div class="collapsible-header"><i class="material-icons">speaker_notes</i> Observações</div>
              <div class="collapsible-body">

                <div class="row">
                  <div class="input-field col s12">
                    <textarea name="obs" id="obs" class="materialize-textarea" v-model="fornecedor.obs"></textarea>
                    <label for="obs">Obs</label>
                    <small class="red-text">{{ errors.first('obs') }}</small>
                  </div>
                </div>

              </div>
            </li>

          </ul>

          <div class="row">

            <div class="input-field col s12">
              <button class="waves-effect waves-light btn" :disabled="loading">Salvar</button>
            </div>

          </div>


        </div>

      </div>

    </form>

  </div>
</template>



// WEBPACK FOOTER //
// src/features/fornecedores/fornecedores/form.vue